/** Place fields in form rows of 3 (left → center → right in the grid). */
function chunkInRowsOfThree(fields) {
  const ordered = [];
  for (let i = 0; i < fields.length; i += 3) {
    ordered.push(...fields.slice(i, i + 3));
  }
  return ordered;
}

/**
 * Print certificate layout: all left-column fields (3 per row),
 * then all right-column fields (3 per row).
 */
export function layoutPrintFormFields(leftColumnFields, rightColumnFields) {
  return [
    ...chunkInRowsOfThree(leftColumnFields),
    ...chunkInRowsOfThree(rightColumnFields),
  ];
}

export function layoutFromPrintPairs(pairs) {
  const left = pairs.map((p) => p.left);
  const right = pairs.map((p) => p.right);
  return layoutPrintFormFields(left, right);
}
